import { IApplicationState } from '../../types/redux';
import { MOSCOW_AND_REGION } from '../../constants/geo';
import { isAvailableInRegions } from '../../selectors/regions';
import { isConsultantPopupExperimentActive } from '../../utils/experiments/isConsultantPopupExperimentActive';

export function isNewbuildingConsultantPopupAvailable(state: IApplicationState): boolean {
  const { abUseExperiments, newbuildingConsultant } = state;

  return (
    !!newbuildingConsultant.accountName &&
    isConsultantPopupExperimentActive(abUseExperiments) &&
    isAvailableInRegions(MOSCOW_AND_REGION)(state)
  );
}

export function isNewbuildingConsultantPopupOpen(state: IApplicationState) {
  return state.newbuildingConsultant.consultantPopupOpen;
}
